import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';

import logo from '../assets/logo.png';

import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import PinterestIcon from '@material-ui/icons/Pinterest';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.common.black,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    logoImage: {
        width: "70px",
        userSelect: "none",
        [theme.breakpoints.down("md")]: {
            width: "60px"
        },
        [theme.breakpoints.down("sm")]: {
            width: "70px",
        },
        [theme.breakpoints.down("xs")]: {
            width: "60px",
        },
    },
    logoTitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "25px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "30px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "20px",
        },
    },
    logoSubtitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "9.5px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "12px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "7px",
        },
    },
    topBar: {
        borderBottom: "1px solid #cccccc55",
    },
    topBarText: {
        color: theme.palette.common.white,
        fontSize: "0.8rem",
        fontWeight: 300,
        [theme.breakpoints.down("md")]: {
            fontSize: "0.7rem",
        },
    },
    topBarIcon: {
        color: theme.palette.common.white,
        fontSize: "1.5rem",
        [theme.breakpoints.down("md")]: {
            fontSize: "1.4rem",
        },
    },
    instagram: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#e4405f",
        }
    },
    facebook: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#3b5999",
        }
    },
    pinterest: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#bd081c",
        }
    },
    menu: {
        cursor: "pointer",
        color: "#ccc",
        transition: "0.5s",
        "&:hover": {
            color: theme.palette.primary.main,
        }
    },
    menuSelected: {
        color: `${theme.palette.primary.main} !important`,
        fontWeight:"bold"
    },
    header: {
        backgroundColor: theme.palette.common.black,
    },
    sticky: {
        zIndex: 9999,
        position: "fixed",
        top: "0",
        left: "0",
        paddingLeft: "15%",
        paddingRight: "15%",
        paddingBottom: "20px",
        paddingTop: "20px",
        width: "100%",
    },
    menuContainer: {
        position: 'absolute',
        zIndex: 2,
        right: '20px',
        top: "20px",
    },
    menuHamTop: {
        backgroundColor: theme.palette.primary.main,
        padding: "10px 10px",
        borderRadius: "35px",
        boxShadow: '0 0 100px -5px rgba(0,0,0,.25)',
    },
    menuIcon: {
        fontSize: "2.2rem",
        transition: '0.3s',
        cursor: "pointer",
        userSelect: "none",
        "&:hover": {
            color: theme.palette.primary.main,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.8rem",
        },
    },
    menuPop: {

    },
    menuPopContent: {
        padding: "60px 10px",
        backgroundColor: theme.palette.common.black,
        height: "100%"
    },
    tab: {
        fontFamily: "Rambla, sans-serif",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: 1.75,

        marginBottom: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",

        borderBottom: `solid ${theme.palette.common.white} 1px`,
    },
    root: {
        position: 'fixed',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
    },
}))

function ScrollTop(props) {
    const { children, window } = props;
    const classes = useStyles();

    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector('#home');

        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={classes.root}>
                {children}
            </div>
        </Zoom>
    );
}

export default function Navbar(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();

    const menuSelected = props.menuSelected;
    const setMenuSelected = props.setMenuSelected;

    const [menuCheck, setMenuCheck] = useState(false);


    const homeLink = () => {
        setMenuSelected("home");
        //history.push('/');
    };
    const servicesLink = () => {
        setMenuSelected("services");
        // history.push('/services');
    };
    const projectsLink = () => {
        // history.push('/projects');
        setMenuSelected("projects");
    };
    const aboutLink = () => {
        //  history.push('/about');
        setMenuSelected("about");
    };
    const contactLink = () => {
        //  history.push('/contact');
        setMenuSelected("contact");
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleScroll = (event) => {
        if (!matchesSM) {
            var header = document.getElementById("myHeader");
            var sticky = header.offsetTop;

            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
                setSticky(true);
            } else {
                header.classList.remove("sticky");
                setSticky(false);
            }
        }
    }

    const [sticky, setSticky] = useState(false);


    return (
        <React.Fragment >
            <div className={classes.container} id="home">
                {/* Scroll Top */}
                <ScrollTop >
                    <Fab color="primary" size="small" aria-label="scroll back to top" style={{
                        borderRadius: 0,
                        clipPath: "polygon(0% 50%, 50% 0%, 100% 50%, 100% 100%, 0% 100%)",

                    }}>
                        <MeetingRoomIcon style={{ marginTop: "21px" }} />
                    </Fab>
                </ScrollTop>

                {/* { Top bar } */}
                <Hidden smDown>
                    <div className={classes.topBar} >
                        <Grid item container direction="row" justify="space-between" alignItems="center">
                            <Grid item>
                                <Grid item container direction="row" alignItems="center" spacing={2}>

                                    <Grid item >
                                        <Grid item container direction="row" alignItems="center" spacing={1} >
                                            <Grid item>
                                                <LocationOnOutlinedIcon className={classes.topBarIcon} />
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle1" className={classes.topBarText}>
                                                    9446 Onion Patch Drive <br/> Burke, Virginia 22015
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item >
                                        <Grid item container direction="row" alignItems="center" spacing={1} >
                                            <Grid item>
                                                <MailOutlineOutlinedIcon className={classes.topBarIcon} />
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle1" className={classes.topBarText}>
                                                    TechnoConstruction1@gmail.com
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item >
                                        <Grid item container direction="row" alignItems="center" spacing={1} >
                                            <Grid item>
                                                <SmartphoneOutlinedIcon className={classes.topBarIcon} />
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle1" className={classes.topBarText} style={{ lineHeight: 1.2 }}>
                                                    +1 (703) 929-6163
                                                    <br />
                                                    +1 (202) 909-6603
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid item container direction="row" alignItems="center" spacing={2}>
                                    <Grid item>
                                        <Link color="inherit" href="https://www.instagram.com/ultimatehomedesign/" target="blank">
                                            <InstagramIcon className={`${classes.topBarIcon} ${classes.instagram}`} />
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link color="inherit" href="https://www.facebook.com/Ultimatehomedesign" target="blank">
                                            <FacebookIcon className={`${classes.topBarIcon} ${classes.facebook}`} />
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link color="inherit" href="https://www.pinterest.com/ultimatehomed" target="blank">
                                            <PinterestIcon className={`${classes.topBarIcon} ${classes.pinterest}`} />
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Hidden>


                {/* { Menu } */}
                <Grid container style={{ paddingTop: "20px", paddingBottom: matchesSM ? "20px" : sticky ? "71px" : "20px" }} id={"myHeader"} >
                    <Grid item container direction={matchesSM ? "column" : "row"} justify="space-between" alignItems="center" className={matchesSM ? null : `${classes.header} ` + `${matchesSM ? null : sticky ? classes.sticky : null}`}>
                        <Grid item >
                            <Grid item container direction="row" alignItems="center" spacing={2}>

                                <img src={logo} alt="Logo" className={classes.logoImage} />

                                <Grid item >
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography variant="h1" style={{ color: theme.palette.common.white }} className={classes.logoTitle}>
                                                Techno Construction, LLC
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h2" style={{ color: theme.palette.common.white, letterSpacing: "3px", }} className={classes.logoSubtitle}>
                                                A modern approach to your space planning
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Hidden smDown>
                            <Grid item style={{ paddingTop: matchesSM ? "50px" : null }} >
                                <Grid item container direction="row" alignItems="center" spacing={2} >
                                    <Grid item component={Link} href={"/"} style={{ textDecoration: "none" }}>
                                        <Typography variant="subtitle2" className={`${classes.menu} ` + `${menuSelected === "home" ? classes.menuSelected : null}`} onClick={homeLink}>
                                            Home
                                        </Typography>
                                    </Grid>
                                    <Grid item component={Link} href={"/services"} style={{ textDecoration: "none" }}>
                                        <Typography variant="subtitle2" className={`${classes.menu} ` + `${menuSelected === "services" ? classes.menuSelected : null}`} onClick={servicesLink}>
                                            Services
                                        </Typography>
                                    </Grid>
                                    <Grid item component={Link} href={"/projects"} style={{ textDecoration: "none" }}>
                                        <Typography variant="subtitle2" className={`${classes.menu} ` + `${menuSelected === "projects" ? classes.menuSelected : null}`} onClick={projectsLink}>
                                            Projects
                                        </Typography>
                                    </Grid>
                                    <Grid item component={Link} href={"/about"} style={{ textDecoration: "none" }}>
                                        <Typography variant="subtitle2" className={`${classes.menu} ` + `${menuSelected === "about" ? classes.menuSelected : null}`} onClick={aboutLink}>
                                            About
                                        </Typography>
                                    </Grid>
                                    <Grid item component={Link} href={"/contact"} style={{ textDecoration: "none" }}>
                                        <Typography variant="subtitle2" className={`${classes.menu} ` + `${menuSelected === "contact" ? classes.menuSelected : null}`} onClick={contactLink}>
                                            Contact
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Hidden>

                    </Grid>
                </Grid>
            </div>


            {/*----- Mobile View -----*/}
            <Hidden mdUp>

                <Grid item className={classes.menuContainer} style={{ position: "fixed" }}>
                    <Grid item container direction="row-reverse" justify="center" >

                        <Grid item>
                            <Grid item container className={classes.menuHamTop}>
                                <MenuOutlinedIcon className={classes.menuIcon} style={{ color: theme.palette.common.white }} onClick={() => setMenuCheck(!menuCheck)} />
                            </Grid>

                            <Grid item >
                                <SwipeableDrawer
                                    anchor="left"
                                    open={menuCheck}
                                    onClose={() => setMenuCheck(false)}
                                    onOpen={() => setMenuCheck(true)}
                                    className={classes.menuPop}
                                >
                                    <Grid item container direction="column" justify="space-between" className={classes.menuPopContent}>
                                        <Grid item>
                                            <Tabs
                                                orientation="vertical"
                                                variant="fullWidth"
                                                // value={menuSelected} // value={window.location.pathname}
                                                // onChange={handleChange}
                                                aria-label="Vertical tabs example"
                                            // indicatorColor="primary"
                                            // textColor="secondary"
                                            >
                                                <Tab component={Link} href={"/"} className={`${classes.tab} ` + `${menuSelected == "home" ? classes.menuSelected : null}`} style={{ textDecoration: "none", color: theme.palette.common.white }} label="Home" onClick={() => { homeLink(); setMenuCheck(false) }} />
                                                <Tab component={Link} href={"/services"} className={`${classes.tab} ` + `${menuSelected == "services" ? classes.menuSelected : null}`} style={{ textDecoration: "none", color: theme.palette.common.white }} label="Services" onClick={() => { servicesLink(); setMenuCheck(false) }} />
                                                <Tab component={Link} href={"/projects"} className={`${classes.tab} ` + `${menuSelected == "projects" ? classes.menuSelected : null}`} style={{ textDecoration: "none", color: theme.palette.common.white }} label="Projects" onClick={() => { projectsLink(); setMenuCheck(false) }} />
                                                <Tab component={Link} href={"/about"} className={`${classes.tab} ` + `${menuSelected == "about" ? classes.menuSelected : null}`} style={{ textDecoration: "none", color: theme.palette.common.white }} label="About" onClick={() => { aboutLink(); setMenuCheck(false) }} />
                                                <Tab component={Link} href={"/contact"} className={`${classes.tab} ` + `${menuSelected == "contact" ? classes.menuSelected : null}`} style={{ textDecoration: "none", color: theme.palette.common.white }} label="Contact" onClick={() => { contactLink(); setMenuCheck(false) }} />
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                </SwipeableDrawer>
                            </Grid >
                        </Grid >



                    </Grid >
                </Grid >

            </Hidden>
        </React.Fragment >

    );
}
